export default {
  AUTHENTICATE: 'AUTHENTICATE',
  CLEAR_USER: 'LOGOUT',
  SET_CURRENT_USER: 'SET_CURRENT_USER',
  SET_CURRENT_ACCOUNT_ID: 'SET_CURRENT_ACCOUNT_ID',
  SET_CURRENT_USER_AVAILABILITY: 'SET_CURRENT_USER_AVAILABILITY',
  SET_CURRENT_USER_UI_SETTINGS: 'SET_CURRENT_USER_UI_SETTINGS',
  SET_BASE_PATH: 'SET_BASE_PATH',
  SET_CONTACT_STATUS: 'SET_CONTACT_STATUS',
  SET_COMMUNAL_INBOXES: 'SET_COMMUNAL_INBOXES',
  SET_USER_PLAN: 'SET_USER_PLAN',
  SET_SUBSCRIPTION_PLANS: 'SET_SUBSCRIPTION_PLANS',
  SET_ADDON_PLANS: 'SET_ADDON_PLANS',
  SET_CURRENT_USER_PROFILE_FLAG: 'SET_CURRENT_USER_PROFILE_FLAG',
  SET_CURRENT_USER_PROFILE: 'SET_CURRENT_USER_PROFILE',
  TOGGLE_MOBILE_NAV: 'TOGGLE_MOBILE_NAV',

  // call
  // UPDATE_CALL_STATE:"UPDATE_CALL_STATE",
  // RESET_CALL_STATE:"RESET_CALL_STATE",
  UPDATE_UNIFIED_CALL: 'UPDATE_UNIFIED_CALL',
  RESET_UNIFIED_CALL: 'RESET_UNIFIED_CALL',
  UPDATE_UNIFIED_UI: 'UPDATE_UNIFIED_UI',
  RESET_UNIFIED_UI: 'RESET_UNIFIED_UI',
  SET_CALL_ACCEPTING: 'SET_CALL_ACCEPTING',
  SET_CALL_REJECTING: 'SET_CALL_REJECTING',
  SET_CALL_ACCEPTED: 'SET_CALL_ACCEPTED',

  // Chat List
  RECEIVE_CHAT_LIST: 'RECEIVE_CHAT_LIST',
  SET_ALL_CONVERSATION: 'SET_ALL_CONVERSATION',
  SET_lAST_CONVERSATION_ACTIVITY: 'SET_lAST_CONVERSATION_ACTIVITY',
  EMPTY_ALL_CONVERSATION: 'EMPTY_ALL_CONVERSATION',
  // EMPTY_ONLY_CONVERSATION_LIST: 'EMPTY_ONLY_CONVERSATION_LIST',
  SET_CONV_TAB_META: 'SET_CONV_TAB_META',
  CLEAR_LIST_LOADING_STATUS: 'CLEAR_LIST_LOADING_STATUS',
  SET_LIST_LOADING_STATUS: 'SET_LIST_LOADING_STATUS',
  SET_ALL_MESSAGES_LOADED: 'SET_ALL_MESSAGES_LOADED',
  CLEAR_ALL_MESSAGES_LOADED: 'CLEAR_ALL_MESSAGES_LOADED',
  CHANGE_CHAT_STATUS_FILTER: 'CHANGE_CHAT_STATUS_FILTER',
  UPDATE_ASSIGNEE: 'UPDATE_ASSIGNEE',
  UPDATE_CONVERSATION_CONTACT: 'UPDATE_CONVERSATION_CONTACT',
  CLEAR_CONTACT_CONVERSATIONS: 'CLEAR_CONTACT_CONVERSATIONS',
  SET_CONVERSATION_FILTERS: 'SET_CONVERSATION_FILTERS',
  CLEAR_CONVERSATION_FILTERS: 'CLEAR_CONVERSATION_FILTERS',

  SET_TWL_INCOMMING_CALL: 'SET_TWL_INCOMMING_CALL',
  SET_TWL_OUTGOING_CALL: 'SET_TWL_OUTGOING_CALL',
  SET_TWL_END_CALL: 'SET_TWL_END_CALL',
  SET_TWL_CALL_STATUS: 'SET_TWL_CALL_STATUS',
  CLEAR_TWL_CALL: 'CLEAR_TWL_CALL',
  UPDATE_TWL_CALL_CONTACT: 'UPDATE_TWL_CALL_CONTACT',
  UPDATE_TWL_CALL_DURATION: 'UPDATE_TWL_CALL_DURATION',

  SET_CURRENT_CHAT_WINDOW: 'SET_CURRENT_CHAT_WINDOW',
  CLEAR_CURRENT_CHAT_WINDOW: 'CLEAR_CURRENT_CHAT_WINDOW',
  CLEAR_ALL_MESSAGES: 'CLEAR_ALL_MESSAGES',
  CHANGE_CONVERSATION_STATUS: 'CHANGE_CONVERSATION_STATUS',
  ADD_CONVERSATION: 'ADD_CONVERSATION',
  UPDATE_CONVERSATION: 'UPDATE_CONVERSATION',
  MUTE_CONVERSATION: 'MUTE_CONVERSATION',
  UNMUTE_CONVERSATION: 'UNMUTE_CONVERSATION',
  ASSIGN_AGENT: 'ASSIGN_AGENT',
  ASSIGN_TEAM: 'ASSIGN_TEAM',
  SET_CHAT_META: 'SET_CHAT_META',
  ADD_MESSAGE: 'ADD_MESSAGE',
  DELETE_MESSAGE: 'DELETE_MESSAGE',
  ADD_PENDING_MESSAGE: 'ADD_PENDING_MESSAGE',
  MARK_MESSAGE_READ: 'MARK_MESSAGE_READ',
  SET_PREVIOUS_CONVERSATIONS: 'SET_PREVIOUS_CONVERSATIONS',
  SET_ACTIVE_INBOX: 'SET_ACTIVE_INBOX',
  UPDATE_CONVERSATION_CUSTOM_ATTRIBUTES:
    'UPDATE_CONVERSATION_CUSTOM_ATTRIBUTES',

  SET_CONVERSATION_CAN_REPLY: 'SET_CONVERSATION_CAN_REPLY',
  SET_CONVERSATION_ATTACHMENTS: 'SET_CONVERSATION_ATTACHMENTS',
  SET_CONVERSATION_SUMMARY: 'SET_CONVERSATION_SUMMARY',

  // Inboxes
  SET_INBOXES_UI_FLAG: 'SET_INBOXES_UI_FLAG',
  SET_INBOXES: 'SET_INBOXES',
  SET_INBOX_ITEM: 'SET_INBOX_ITEM',
  ADD_INBOXES: 'ADD_INBOXES',
  EDIT_INBOXES: 'EDIT_INBOXES',
  DELETE_INBOXES: 'DELETE_INBOXES',

  // Agent
  SET_ACCOUNT_UI_FLAG: 'SET_ACCOUNT_UI_FLAG',
  SET_ACCOUNTS: 'SET_ACCOUNTS',
  ADD_ACCOUNT: 'ADD_ACCOUNT',
  EDIT_ACCOUNT: 'EDIT_ACCOUNT',
  DELETE_ACCOUNT: 'DELETE_AGENT',
  SET_CURRENCY_LIST: 'SET_CURRENCY_LIST',

  // Agent
  SET_AGENT_FETCHING_STATUS: 'SET_AGENT_FETCHING_STATUS',
  SET_AGENT_CREATING_STATUS: 'SET_AGENT_CREATING_STATUS',
  SET_AGENT_UPDATING_STATUS: 'SET_AGENT_UPDATING_STATUS',
  SET_AGENT_DELETING_STATUS: 'SET_AGENT_DELETING_STATUS',
  SET_AGENTS: 'SET_AGENTS',
  ADD_AGENT: 'ADD_AGENT',
  EDIT_AGENT: 'EDIT_AGENT',
  DELETE_AGENT: 'DELETE_AGENT',
  UPDATE_AGENTS_PRESENCE: 'UPDATE_AGENTS_PRESENCE',

  // Canned Response
  SET_CANNED_UI_FLAG: 'SET_CANNED_UI_FLAG',
  SET_CANNED: 'SET_CANNED',
  ADD_CANNED: 'ADD_CANNED',
  EDIT_CANNED: 'EDIT_CANNED',
  DELETE_CANNED: 'DELETE_CANNED',

  // Labels
  SET_LABEL_UI_FLAG: 'SET_LABEL_UI_FLAG',
  SET_LABELS: 'SET_LABELS',
  ADD_LABEL: 'ADD_LABEL',
  EDIT_LABEL: 'EDIT_LABEL',
  DELETE_LABEL: 'DELETE_LABEL',

  // Integrations
  SET_INTEGRATIONS_UI_FLAG: 'SET_INTEGRATIONS_UI_FLAG',
  SET_INTEGRATIONS: 'SET_INTEGRATIONS',
  ADD_INTEGRATION: 'ADD_INTEGRATION',
  DELETE_INTEGRATION: 'DELETE_INTEGRATION',
  ADD_INTEGRATION_HOOKS: 'ADD_INTEGRATION_HOOKS',
  DELETE_INTEGRATION_HOOKS: 'DELETE_INTEGRATION_HOOKS',

  // WebHook
  SET_WEBHOOK_UI_FLAG: 'SET_WEBHOOK_UI_FLAG',
  SET_WEBHOOK: 'SET_WEBHOOK',
  ADD_WEBHOOK: 'ADD_WEBHOOK',
  DELETE_WEBHOOK: 'DELETE_WEBHOOK',
  UPDATE_WEBHOOK: 'UPDATE_WEBHOOK',

  // Status
  SET_STATUS: 'SET_STATUS',

  // Contacts
  SET_CONTACT_META: 'SET_CONTACT_META',
  SET_CONTACT_UI_FLAG: 'SET_CONTACT_UI_FLAG',
  SET_CONTACT_ITEM: 'SET_CONTACT_ITEM',
  SET_CONTACTS: 'SET_CONTACTS',
  SET_CONTACTS_INFINITYSCROLL: 'SET_CONTACTS_INFINITYSCROLL',
  CLEAR_CONTACTS: 'CLEAR_CONTACTS',
  EDIT_CONTACT: 'EDIT_CONTACT',
  EDIT_CONTACTS: 'EDIT_CONTACTS',
  DELETE_CONTACT: 'DELETE_CONTACT',
  UPDATE_CONTACTS_PRESENCE: 'UPDATE_CONTACTS_PRESENCE',
  SET_CONTACT_FILTERS: 'SET_CONTACT_FILTERS',
  CLEAR_CONTACT_FILTERS: 'CLEAR_CONTACT_FILTERS',

  // Notifications
  SET_NOTIFICATIONS_META: 'SET_NOTIFICATIONS_META',
  SET_NOTIFICATIONS_UNREAD_COUNT: 'SET_NOTIFICATIONS_UNREAD_COUNT',
  SET_NOTIFICATIONS_UI_FLAG: 'SET_NOTIFICATIONS_UI_FLAG',
  UPDATE_NOTIFICATION: 'UPDATE_NOTIFICATION',
  UPDATE_ALL_NOTIFICATIONS: 'UPDATE_ALL_NOTIFICATIONS',
  SET_NOTIFICATIONS_ITEM: 'SET_NOTIFICATIONS_ITEM',
  SET_NOTIFICATIONS: 'SET_NOTIFICATIONS',
  CLEAR_NOTIFICATIONS: 'CLEAR_NOTIFICATIONS',
  EDIT_NOTIFICATIONS: 'EDIT_NOTIFICATIONS',
  UPDATE_NOTIFICATIONS_PRESENCE: 'UPDATE_NOTIFICATIONS_PRESENCE',

  // Contact Conversation
  SET_CONTACT_CONVERSATIONS_UI_FLAG: 'SET_CONTACT_CONVERSATIONS_UI_FLAG',
  SET_CONTACT_CONVERSATIONS: 'SET_CONTACT_CONVERSATIONS',
  ADD_CONTACT_CONVERSATION: 'ADD_CONTACT_CONVERSATION',
  DELETE_CONTACT_CONVERSATION: 'DELETE_CONTACT_CONVERSATION',

  // Contact Label
  SET_CONTACT_LABELS_UI_FLAG: 'SET_CONTACT_LABELS_UI_FLAG',
  SET_CONTACT_LABELS: 'SET_CONTACT_LABELS',

  // Conversation Label
  SET_CONVERSATION_LABELS_UI_FLAG: 'SET_CONVERSATION_LABELS_UI_FLAG',
  SET_CONVERSATION_LABELS: 'SET_CONVERSATION_LABELS',
  SET_BULK_CONVERSATION_LABELS: 'SET_BULK_CONVERSATION_LABELS',

  // Reports
  SET_ACCOUNT_REPORTS: 'SET_ACCOUNT_REPORTS',
  SET_ACCOUNT_SUMMARY: 'SET_ACCOUNT_SUMMARY',
  TOGGLE_ACCOUNT_REPORT_LOADING: 'TOGGLE_ACCOUNT_REPORT_LOADING',
  SET_SALES_REPORT_UI_FLAG: 'SET_SALES_REPORT_UI_FLAG',
  SET_SALES_REPORT: 'SET_SALES_REPORT',

  // Conversation Metadata
  SET_CONVERSATION_METADATA: 'SET_CONVERSATION_METADATA',

  // Conversation Page
  SET_CURRENT_PAGE: 'SET_CURRENT_PAGE',
  SET_CONVERSATION_END_REACHED: 'SET_CONVERSATION_END_REACHED',
  CLEAR_CONVERSATION_PAGE: 'CLEAR_CONVERSATION_PAGE',

  // Notification Settings
  SET_USER_NOTIFICATION_UI_FLAG: 'SET_USER_NOTIFICATION_UI_FLAG',
  SET_USER_NOTIFICATION: 'SET_USER_NOTIFICATION',

  // User Typing
  ADD_USER_TYPING_TO_CONVERSATION: 'ADD_USER_TYPING_TO_CONVERSATION',
  REMOVE_USER_TYPING_FROM_CONVERSATION: 'REMOVE_USER_TYPING_FROM_CONVERSATION',

  // Conversation Search
  SEARCH_CONVERSATIONS_SET: 'SEARCH_CONVERSATIONS_SET',
  SEARCH_CONVERSATIONS_SET_UI_FLAG: 'SEARCH_CONVERSATIONS_SET_UI_FLAG',

  // Campaigns
  SET_CAMPAIGN_UI_FLAG: 'SET_CAMPAIGN_UI_FLAG',
  SET_CAMPAIGNS: 'SET_CAMPAIGNS',
  SET_CAMPAIGNS_BY_PAGE: 'SET_CAMPAIGNS_BY_PAGE',
  ADD_CAMPAIGN: 'ADD_CAMPAIGN',
  EDIT_CAMPAIGN: 'EDIT_CAMPAIGN',
  DELETE_CAMPAIGN: 'DELETE_CAMPAIGN',
  SET_EXPRESSBOT_UI_FLAG: 'SET_EXPRESSBOT_UI_FLAG',
  SET_EXPRESSBOTS: 'SET_EXPRESSBOTS',
  SET_CAMPAIGN_FORMS_UI_FLAG: 'SET_CAMPAIGN_FORMS_UI_FLAG',
  SET_CAMPAIGN_FORMS: 'SET_CAMPAIGN_FORMS',
  SET_CAMPAIGN_FORMS_META: 'SET_CAMPAIGN_FORMS_META',

  SET_CMPN_FORMS_RESPONDERS: 'SET_CMPN_FORMS_RESPONDERS',
  SET_CMPN_FORMS_RESPONDER_META: 'SET_CMPN_FORMS_RESPONDER_META',
  SET_CMPN_FORMS_RESPONDER_UI_FLAG: 'SET_CMPN_FORMS_RESPONDER_UI_FLAG',

  SET_EVALUATION_UI_FLAG: 'SET_EVALUATION_UI_FLAG',
  SET_EVALUATIONS: 'SET_EVALUATIONS',
  SET_EVALUATIONS_META: 'SET_EVALUATIONS_META',
  SET_EVALUATION_CREATE: 'SET_EVALUATION_CREATE',
  SET_EVALUATION_UPDATE: 'SET_EVALUATION_UPDATE',
  SET_EVALUATION_DELETE: 'SET_EVALUATION_DELETE',
  SET_EVALUATION_REPORTS: 'SET_EVALUATION_REPORTS',
  SET_EVALUATION_REPORT_META: 'SET_EVALUATION_REPORT_META',

  // tools
  SET_TOOLS_UI_FLAG: 'SET_TOOLS_UI_FLAG',
  SET_TOOLS: 'SET_TOOLS',
  SET_TOOLS_META: 'SET_TOOLS_META',
  SET_TOOLS_CREATE: 'SET_TOOLS_CREATE',
  SET_TOOLS_UPDATE: 'SET_TOOLS_UPDATE',
  SET_TOOLS_DELETE: 'SET_TOOLS_DELETE',

  SET_KNOWLEDGE: 'SET_KNOWLEDGES',
  SET_KNOWLEDGE_META: 'SET_KNOWLEDGE_META',
  SET_KNOWLEDGE_CREATE: 'SET_KNOWLEDGE_CREATE',
  SET_KNOWLEDGE_UPDATE: 'SET_KNOWLEDGE_UPDATE',
  SET_KNOWLEDGE_DELETE: 'SET_KNOWLEDGE_DELETE',

  SET_REPORT_COSTS_UI_FLAG: 'SET_REPORT_COSTS_UI_FLAG',
  SET_REPORT_COSTS: 'SET_REPORT_COSTS',
  SET_REPORT_COSTS_META: 'SET_REPORT_COSTS_META',

  // Contact notes
  SET_CONTACT_NOTES_UI_FLAG: 'SET_CONTACT_NOTES_UI_FLAG',
  SET_CONTACT_NOTES: 'SET_CONTACT_NOTES',
  ADD_CONTACT_NOTE: 'ADD_CONTACT_NOTE',
  EDIT_CONTACT_NOTE: 'EDIT_CONTACT_NOTE',
  DELETE_CONTACT_NOTE: 'DELETE_CONTACT_NOTE',

  // CSAT Responses
  SET_CSAT_RESPONSE_UI_FLAG: 'SET_CSAT_RESPONSE_UI_FLAG',
  SET_CSAT_RESPONSE: 'SET_CSAT_RESPONSE',
  SET_CSAT_RESPONSE_METRICS: 'SET_CSAT_RESPONSE_METRICS',

  // Custom Attributes
  SET_CUSTOM_ATTRIBUTE_UI_FLAG: 'SET_CUSTOM_ATTRIBUTE_UI_FLAG',
  SET_CUSTOM_ATTRIBUTE: 'SET_CUSTOM_ATTRIBUTE',
  ADD_CUSTOM_ATTRIBUTE: 'ADD_CUSTOM_ATTRIBUTE',
  EDIT_CUSTOM_ATTRIBUTE: 'EDIT_CUSTOM_ATTRIBUTE',
  DELETE_CUSTOM_ATTRIBUTE: 'DELETE_CUSTOM_ATTRIBUTE',
  SET_LLM_CONTACT_ATTRIBUTE: 'SET_LLM_CONTACT_ATTRIBUTE',

  // Automations
  SET_AUTOMATION_UI_FLAG: 'SET_AUTOMATION_UI_FLAG',
  SET_AUTOMATIONS: 'SET_AUTOMATIONS',
  ADD_AUTOMATION: 'ADD_AUTOMATION',
  EDIT_AUTOMATION: 'EDIT_AUTOMATION',
  DELETE_AUTOMATION: 'DELETE_AUTOMATION',

  // Custom Views
  SET_CUSTOM_VIEW_UI_FLAG: 'SET_CUSTOM_VIEW_UI_FLAG',
  SET_CUSTOM_VIEW: 'SET_CUSTOM_VIEW',
  ADD_CUSTOM_VIEW: 'ADD_CUSTOM_VIEW',
  DELETE_CUSTOM_VIEW: 'DELETE_CUSTOM_VIEW',

  // Usage Report
  SET_USAGE_REPORTS: 'SET_USAGE_REPORTS',
  SET_BOTS_REPORTS: 'SET_BOTS_REPORTS',
  SET_QUOTA_REPORTS: 'SET_QUOTA_REPORTS',
  TOGGLE_USAGE_BILLING_REPORT_LOADING: 'TOGGLE_USAGE_BILLING_REPORT_LOADING',
  SET_USAGES_ORDER_REPORTS: 'SET_USAGES_ORDER_REPORTS',
  SET_USAGES_ORDER_META: 'SET_USAGES_ORDER_META',
  SET_EXPIRED_CREDIT_REPORTS: 'SET_EXPIRED_CREDIT_REPORTS',
  SET_EXPIRED_CREDIT_META: 'SET_EXPIRED_CREDIT_META',
  TOGGLE_USAGE_MEETING_REPORT_LOADING: 'TOGGLE_USAGE_MEETING_REPORT_LOADING',
  SET_MEETING_USAGES_REPORTS: 'SET_MEETING_USAGES_REPORTS',
  SET_MEETING_USAGE_META: 'SET_MEETING_USAGE_META',
  SET_TRANSACTION_SUMMARY_REPORTS: 'SET_TRANSACTION_SUMMARY_REPORTS',
  SET_TRANSACTION_USAGE_META: 'SET_TRANSACTION_USAGE_META',
  SET_TRANSACTION_USAGES_REPORTS: 'SET_TRANSACTION_USAGES_REPORTS',

  // Meetings
  SET_MEETINGS_UI_FLAG: 'SET_MEETINGS_UI_FLAG',
  SET_MEETING_LIST: 'SET_MEETING_LIST',
  SET_MEETING_REPORTS: 'SET_MEETING_REPORTS',
  SET_MTNG_BY_CONTACT_UIFLAG: 'SET_MTNG_BY_CONTACT_UIFLAG',
  SET_MTNG_BY_CONTACT_REPORTS: 'SET_MTNG_BY_CONTACT_REPORTS',
  SET_MTNG_BY_CONTACT_META: 'SET_MTNG_BY_CONTACT_META',

  // Grant Credit
  SET_GRANT_CREDIT_UI_FLAG: 'SET_GRANT_CREDIT_UI_FLAG',
  SET_GRANT_CREDITS: 'SET_GRANT_CREDITS',
  CREATE_GRANT_CREDIT: 'CREATE_GRANT_CREDIT',
  UPDATE_GRANT_CREDIT: 'UPDATE_GRANT_CREDIT',
  DELETE_GRANT_CREDIT: 'DELETE_GRANT_CREDIT',
  SEARCH_GRANT_CREDIT: 'SEARCH_GRANT_CREDIT',

  // Catalog Products
  SET_CATALOG_PRODUCT_UI_FLAG: 'SET_CATALOG_PRODUCT_UI_FLAG',
  SET_CATALOG_CATAGORIES: 'SET_CATALOG_CATAGORIES',
  SET_CATALOG_ITEMS_PAGINATED: 'SET_CATALOG_ITEMS_PAGINATED',
  SET_CATALOG_ITEMS: 'SET_CATALOG_ITEMS',
  DELETE_CATALOG_ITEMS: 'DELETE_CATALOG_ITEMS',
  SET_CATALOG_CATAGORY_GROPUS: 'SET_CATALOG_CATAGORY_GROPUS',

  // Orders list
  SET_ORDERS_UI_FLAG: 'SET_ORDERS_UI_FLAG',
  SET_ORDERS_LIST: 'SET_ORDERS_LIST',
  SET_ORDERS_LIST_PAGINATED: 'SET_ORDERS_LIST_PAGINATED',
  SET_ORDER_UPDATE: 'SET_ORDER_UPDATE',
  SET_ORDER_CREATE: 'SET_ORDER_CREATE',
  SET_SALES_ORDERS_REPORTS: 'SET_SALES_ORDERS_REPORTS',
  SET_SALES_ORDERS_REPORTS_PAGINATED: 'SET_SALES_ORDERS_REPORTS_PAGINATED',
  SET_PRODUCT_ORDERS_REPORTS: 'SET_PRODUCT_ORDERS_REPORTS',
  SET_PRODUCT_ORDERS_REPORTS_PAGINATED: 'SET_PRODUCT_ORDERS_REPORTS_PAGINATED',

  // coupons
  SET_COUPONS_UI_FLAG: 'SET_COUPONS_UI_FLAG',
  SET_COUPON_LIST: 'SET_COUPON_LIST',
  SET_COUPON_DEFAULT_LIST: 'SET_COUPON_DEFAULT_LIST',
  SET_COUPON_CREATE: 'SET_COUPON_CREATE',
  SET_COUPON_UPDATE: 'SET_COUPON_UPDATE',
  SET_COUPON_DELETE: 'SET_COUPON_DELETE',
  SET_COUPON_REPORTS: 'SET_COUPON_REPORTS',
  SET_COUPON_REPORTS_PAGINATED: 'SET_COUPON_REPORTS_PAGINATED',

  // LLMbots
  SET_LLMBOTS_UI_FLAG: 'SET_LLMBOTS_UI_FLAG',
  SET_LLM_MODEL_LIST: 'SET_LLM_MODEL_LIST',
  SET_LLMBOTS_LIST: 'SET_LLMBOTS_LIST',
  SET_LLM_BOT_CREATE: 'SET_LLM_BOT_CREATE',
  SET_LLM_BOT_UPDATE: 'SET_LLM_BOT_UPDATE',
  SET_LLM_BOT_DELETE: 'SET_LLM_BOT_DELETE',
  SET_LLMBOT_BY_ID: 'SET_LLMBOT_BY_ID',
  SET_LLM_ASSISTANT_LIST: 'SET_LLM_ASSISTANT_LIST',
  SET_LLM_CALL_INBOX_LIST: 'SET_LLM_CALL_INBOX_LIST',
  SET_LLM_CALL_REPORTS: 'SET_LLM_CALL_REPORTS',
  SET_LLM_CALL_REPORTS_META: 'SET_LLM_CALL_REPORTS_META',

  // campaign agents
  SET_CAMPAGENT_UI_FLAG: 'SET_CAMPAGENT_UI_FLAG',
  SET_CAMPAGENT_LIST: 'SET_CAMPAGENT_LIST',
  SET_CAMPAGENT_META: 'SET_CAMPAGENT_META',
  SET_CAMPAGENT_CREATE: 'SET_CAMPAGENT_CREATE',

  // merchant module
  SET_MERCHANT_UI_FLAG: 'SET_MERCHANT_UI_FLAG',
  SET_MERCHANT_DATA: 'SET_MERCHANT_DATA',

  // dashboard module
  SET_D_BOARD_UI_FLAG: 'SET_D_BOARD_UI_FLAG',
  SET_D_BOARD_STATS: 'SET_D_BOARD_STATS',

  // scores module
  SET_SCORE_UI_FLAG: 'SET_SCORE_UI_FLAG',
  SET_SCORE: 'SET_SCORE',

  // levels module
  SET_LEVELS_UI_FLAG: 'SET_LEVELS_UI_FLAG',
  SET_LEVELS: 'SET_LEVELS',
  SET_LEADERBOARD_UI_FLAG: 'SET_LEADERBOARD_UI_FLAG',
  SET_LEADERBOARD: 'SET_LEADERBOARD',

  // interaction histories
  SET_INTERACTION_HISTORIES_UI_FLAG: 'SET_INTERACTION_HISTORIES_UI_FLAG',
  SET_INTERACTION_HISTORIES_META: 'SET_INTERACTION_HISTORIES_META',
  SET_INTERACTION_HISTORIES_LIST: 'SET_INTERACTION_HISTORIES_LIST',
};
